import { Trans } from "@lingui/macro";
import { InfoOutlined } from "@mui/icons-material";
import { Grid, IconButton, Popover, Stack } from "@mui/material";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import React from "react";

import { REPLACEMENT_MAP } from "./constants";

const PopoverButton = () => {
	const data = Object.keys(REPLACEMENT_MAP).map((key) => ({
		key,
		label: REPLACEMENT_MAP[key].label,
	}));

	return (
		<PopupState variant="popover" popupId="demo-popup-popover">
			{(popupState) => (
				<>
					<IconButton size="small" color="primary" {...bindTrigger(popupState)}>
						<InfoOutlined />
					</IconButton>
					<Popover
						{...bindPopover(popupState)}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "center",
						}}
					>
						<Stack px={3} py={3} spacing={1}>
							<Stack direction="row" spacing={1}>
								<InfoOutlined color="primary" />
								<Stack className="text-sm">
									<div className="font-semibold">
										<Trans>Template Usage Guide</Trans>
									</div>
									<div>
										<Trans>
											Use merge tags to insert personalized or dynamic content
											from your audience into the message.
										</Trans>
									</div>
								</Stack>
							</Stack>
							<Grid container spacing={1} pl={3} className="text-sm">
								{data.map((item) => (
									<Grid key={item.key} item xs={6}>
										<Stack>
											<div className="font-semibold">{item.key}</div>
											<div>{item.label}</div>
										</Stack>
									</Grid>
								))}
							</Grid>
						</Stack>
					</Popover>
				</>
			)}
		</PopupState>
	);
};

export default PopoverButton;
